import { Route, Navigate, useNavigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

export default function RedirectRoute() {

    const location = useLocation()
    return <Navigate to={"/"} replace state={{ from: location, redirect: true }} />
}